const ACTOR_TYPE = {
    AGENT: 'Agent',
    AUTO: 'Auto'
}

const SERVICE_TYPE_MAPPING = {
    bikeTaxi: 'app',
    delivery: 'delivery',
    auto: 'auto'
}

const PERMISSION_MAPPING = {
    EDIT_RIDER_ACCESS: ['edit_captain'],
    VIEW_ACCESS: ['view_captain'],
    EDIT_MOBILE_ACCESS: ['edit_captain_mobile'],
    EDIT_FLEET_ATTACH_DETACH_ACCESS: ['edit_fleet_attach_detach_access'],
    DOC_REJECTION_ACCESS: ['doc_rejection_access']
}

const ORDER_TYPE = {
    SME: 'sme'
};

const FILE_TYPE = {
    IMAGE: 'image'
}

const SUPPLY_PERMISSIONS = [
    'edit_captain', 'view_captain', 'edit_captain_mobile',
    'edit_merchant', 'view_merchant', 'edit_fleet_attach_detach_access',
    'doc_rejection_access',

    'edit_fleet', 'view_fleet',
    'edit_partner_manager', 'view_partner_manager', 'vehicle_model_list', 'vehicle_model_add', 'vehicle_model_edit',

    'host_agent_view', 'host_agent_edit'
];

const SUPPLY_DASHBOARD = {
    SOURCE: 'supply-dashboard'
}

const SERVICE_MANAGER_ASSETS = {
    app: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/service-icons/captain_service_manager_bike_taxi.png',
    rental: 'https://cust-rapido-images.s3.amazonaws.com/70e6aa700f99c8d1f3469a9452efb675_1615192380837.png',
    food: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/service-icons/captain_service_manager_food.png',
    alcohol: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/service-icons/captain_service_manager_alcohol.png',
    grocery: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/service-icons/captain_service_managet_grocery.png',
    others: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/service-icons/captain_service_manager_package.png',
    auto: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/service-icons/captain_service_manager_auto.png',
    suspended: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/alert_message_icon_warning.png',
    premium: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/service-icons/captain_service_manager_bike_taxi.png',
    suspensionBottomSheet: 'https://cust-rapido-images.s3.ap-south-1.amazonaws.com/Group+2842.png'
}

const SERVICE_STATUS = {
    ACTIVE: 'active',
    SUSPENDED: 'suspended',
    INACTIVE: 'inactive',
    PROCESSING: 'processing',
}

const SUSPENSION_REASONS = {
    RIDER_REJECTED: 'rider_rejected',
    RIDER_REJECT: 'rider_reject',
    RIDER_BUSY: 'rider_busy',
    RATINGS: 'ratings',
    CUSTOMER_CANCELLED: 'customer_cancelled',
    CAPTAIN_DENIED_DUTY: 'captain_denied_duty',
    CHANGE_PAYMENT_MODE: 'change_payment_mode'
}

const LMS_TRAINING = {
    complete: 'complete',
    inComplete: 'incomplete'
}

const DOC_TYPES = {
    DL: 'DL',
    RC: 'RC',
    AADHAR: 'AADHAR',
    PAN: 'PAN'
}

const DOC_TYPES_MAPPING = {
    driverLicense: 'license',
    aadhar: 'aadhar',
    panCard: 'panCard',
    profilePicture: 'profilePicture'
}

const SUPPLY_DASHBOARD_OPERATION_TYPE = "agent-operation";

const DOC_VERIFICATION_STATUS = {
    WARNING: "Warning",
    ACCEPTED: "Accepted",
    REJECTED: "rejected",
    FAILED: "Failed",
    IN_PROGRESS: "In Progress",
    VERIFIED: "Verified",
    INITIATED: "Initiated",
    PROCESSING: "processing",
    APPROVED: "approved",
    ON_HOLD: "onHold",
}

const PAGES_TYPE = {
    BASIC_INFO: 'basic-info',
    PROFILE_PICTURE: 'profile-picture',
    DRIVERS_LICENSE: 'drivers-license',
    REGISTRATION_CARD: 'registration-card',
    ROAD_TAX: 'road-tax',
    MORE_INFO: 'more-info',
    IMAGE_VIEW: 'image-view',
    MERCHANT_INFO: 'merchant-info',
    GST_CERTIFICATE: 'gst-certificate',
    MERCHANT_MORE_INFO: 'merchant-more-info',
    PAN: 'pan',
    AADHAR: 'aadhar',
    SERVICES: 'services',
    AGENT_OPERATION: 'agent-operation',
    PERMIT: 'permit',
    FITNESS: 'fitness',
    INSURANCE: 'insurance'
}

const GEOLAYERS = {
    CITY: 'city'
}
const KAFKA_TOPIC = {
    AGENT_EVENT: "domain.supply_dashboard.agent_events"
}
const KAFKA_EVENT = {

    AGENT_VIEWED: "agent_viewed",

}

const KAFKA_TOPIC_VERSION = {
    AGENT_EVENT: "1.0.0"
}

const CACHE_TTL = {
    TYPE_CONFIG: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
    DEFAULT: 60 * 60 * 1000 // 1 hour in milliseconds
}

const UNKNOWN = 'unknown'

const RIDER_TYPE = {
   No_DL:  "noDl"
}

module.exports = {
    PERMISSION_MAPPING,
    ORDER_TYPE,
    FILE_TYPE,
    SUPPLY_PERMISSIONS,
    ACTOR_TYPE,
    SERVICE_TYPE_MAPPING,
    SUPPLY_DASHBOARD,
    SERVICE_MANAGER_ASSETS,
    SERVICE_STATUS,
    SUSPENSION_REASONS,
    LMS_TRAINING,
    DOC_TYPES: DOC_TYPES,
    SUPPLY_DASHBOARD_OPERATION_TYPE,
    DOC_VERIFICATION_STATUS: DOC_VERIFICATION_STATUS,
    DOC_TYPES_MAPPING: DOC_TYPES_MAPPING,
    PAGES_TYPE,
    GEOLAYERS,
    KAFKA_TOPIC,
    KAFKA_EVENT,
    KAFKA_TOPIC_VERSION,
    CACHE_TTL,
    UNKNOWN,
    RIDER_TYPE:RIDER_TYPE
}
